<! --
/**
* SuiteCRM is a customer relationship management program developed by SalesAgility Ltd.
* Copyright (C) 2021 SalesAgility Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SALESAGILITY, SALESAGILITY DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<!-- Start List View Table Footer Section -->

<div class="list-view-tableactions table-footer">
  <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex">
          <scrm-bulk-action-menu *ngIf="selection && bulkActions"
                                 [selectionSource]="selection"
                                 [actionSource]="bulkActions">
          </scrm-bulk-action-menu>
          <scrm-action-group-menu [config]="tableActions" buttonClass="btn table-action-button"></scrm-action-group-menu>
      </div>
      <div *ngIf="!isPaginationEnabled() && !allLoaded()"
           class="mx-0 pl-0 load-more-style">
          <scrm-load-more
              [loadMoreButton]="getLoadMoreButton()">
          </scrm-load-more>
      </div>
      <div class="mx-0 pl-0 table-pagination-wrapper">
          <scrm-pagination *ngIf="pagination"
                           [allowPagination]="isPaginationEnabled()"
                           [state]="pagination">
          </scrm-pagination>
      </div>
  </div>
</div>

<!-- End List View Table Footer Section -->
